import React from "react";
import { getIcons } from "../Constant/Constant";

const Card = ({ task, index ,title}) => {
  const icons = getIcons();

  console.log("Status ", task.status);
  return (
    <div className="bg-white rounded-md shadow-sm border  cursor-pointer p-2 flex flex-col gap-2 ">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2 ">
          <p className="text-xl font-bold">{task.squareFeet}</p>
          <p className="text-gray-500 text-base font-light pt-1">


            {(task.stage == "Plot Booked" ||task.stage == "Advance Amount Update" ||task.stage == "Fully Registered"
||task.stage == "Registration InProgress" ||task.stage == "Deal Lost After Booking") ? "Fixed" : "Approx"
            }
          </p>
        </div>
        {task.status == "" ? (
          ""
        ) : task.status == "Upcoming" ? (
          <div className="text-xs bg-blue-200 border-blue-300 border px-2 py-1 text-center rounded-full">
            Upcoming{" "}
          </div>
        ) : (
          <div className="text-xs bg-red-200 border-red-300  border px-2 py-1 text-center rounded-full">
            No Update{" "}
          </div>
        )}
      </div>
      <div className="flex justify-between">
        <div className="flex items-center gap-2">
          <img className=" " src={icons.pipelineUserIcon} alt="User" />
          <p title={task.customerName} className="text-l truncate w-[250px]  font-medium">{task.customerName}</p>
        </div>
      </div>

      <div className="bg-[#EEF8FF] rounded-md px-2 flex p-1 ">
        <div className="flex  gap-3">
          <div className="tooltip-container">
            <div className="w-28 whitespace-nowrap">
              <p className="text-sm font-medium truncate">{task.siteName}</p>
              <p className="text-sm truncate text-gray-500 "> {task.stage}</p>
            </div>
            <div className="tooltip-content font-semibold">
              <p>&#9830; {task.siteName}</p>
              {/* <p>&#9830;  {task.stage}</p> */}
            </div>
          </div>

          <div className="tooltip-container">
            <div className="border-l-2 border-r-2 text-left border-white flex flex-col w-24 truncate px-3">
              <p className="truncate text-sm font-medium">
                {task.teamMemberName}
              </p>
              <p className="text-gray-500 truncate text-sm">
                {task.teamDetail}
              </p>
            </div>
            <div className="tooltip-content  font-semibold">
              <p>&#9830; {task.teamMemberName}</p>
              <p>&#9830; {task.teamDetail}</p>
            </div>
          </div>

          <div className="w-20 text-center whitespace-nowrap">
          <p className="font-medium text-sm    ">{task.day}</p>
          <p className="text-gray-500 text-sm ">{task.time}</p>
        </div>
        </div>


      </div>
    {title === "Plot Booked" && (
        <div className="bg-[#EEF8FF] rounded-md px-2 text-center">
        {task.bookedTimestamp != null && task.bookedTimestamp != undefined ? (
          <div className="">
            {task.bookedTimestamp === 0 || task.bookedTimestamp === 1 ? (
              <p>Day from booking: {task.bookedTimestamp}</p>
            ) : (
              <p>Days from booking: {task.bookedTimestamp}</p>
            )}
          </div>
        ) : (
          ""
        )}
      </div>
   ) }

      <div className="bg-[#EEF8FF] rounded-md px-2 flex gap-3">
        {task.recentComment != null && task.recentComment != undefined ? (
          <div>
            <p className="text-[#2C70C1] font-semibold text-base">
              Recent Comment:
            </p>

            <p className="text-sm">{task.recentComment}</p>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default Card;
